// array per i gratta da 'importo'
import { doc, getDoc } from "@firebase/firestore";
import db from "../Firebase-config";
export const getType = async () => {
  const refMessage = doc(db, `type`, "type"); // riferimento del db del message
  const data = await getDoc(refMessage);
  return data.data();
};
